import PropTypes from 'prop-types';
import { Icon } from '@icp/components';
import clsx from 'clsx';
import {
  useEvents,
  useReadonly,
  useSelectedKeyPath,
  useWorkflowTypeNodeMap,
} from './NodeContextProvider';
import Handle from './Handle';

function NodeContent(props) {
  const {
    children,
    keyPath,
    id,
    className,
    name,
    nodeTypeToken,
    icon: iconProp,
    isBranch,
    disableDelete,
  } = props;

  const workflowTypeNodeMap = useWorkflowTypeNodeMap();
  const { onSelectNode, onDeleteNode, onDeleteBranch } = useEvents();
  const selectedKeyPath = useSelectedKeyPath();
  const readonly = useReadonly();

  const { icon } = workflowTypeNodeMap[nodeTypeToken] || {};

  const handleClick = (event) => {
    event.stopPropagation();
    onSelectNode(keyPath);
  };

  const handleDelete = (event) => {
    event.stopPropagation();
    if (isBranch) {
      onDeleteBranch(keyPath);
    } else {
      onDeleteNode(keyPath);
    }
  };

  return (
    <div
      data-id={id}
      className={clsx(
        'icp-workflow-node-content',
        { selected: String(keyPath) === String(selectedKeyPath) },
        className,
      )}
      onClick={handleClick}
    >
      <Handle nodeId={id} type="target" />
      {iconProp !== null && (iconProp || icon) ? (
        <div className="icp-workflow-node-icon-wrapper">
          <div className="icp-workflow-node-icon icp-center">
            <Icon name={iconProp || icon} size={16} />
          </div>
        </div>
      ) : null}
      <div className="icp-workflow-node-name">{children || name}</div>
      {!disableDelete && !readonly ? (
        <button className="icp-workflow-delete-button" onClick={handleDelete}>
          <Icon name="oct:x" size={10} />
        </button>
      ) : null}
      {id !== -1 ? <Handle nodeId={id} type="source" /> : null}
    </div>
  );
}

NodeContent.propTypes = {
  children: PropTypes.node,
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  name: PropTypes.string,
  nodeTypeToken: PropTypes.string,
  icon: PropTypes.string,
  isBranch: PropTypes.bool,
  disableDelete: PropTypes.bool,
};

export default NodeContent;
